const DEFAULT_PUBLIC_ORIGIN = 'https://threatlabz.zscaler.com'

/**
 * Canonical public site origin (SEO, sitemap, share links).
 * Matches `next.config.ts` `siteOrigin()` and sitemap `NEXT_PUBLIC_SITE_URL` usage.
 */
export function getPublicSiteOrigin(): string {
  const raw = process.env.NEXT_PUBLIC_SITE_URL?.trim()
  if (!raw) return DEFAULT_PUBLIC_ORIGIN
  try {
    return new URL(raw).origin
  } catch {
    return DEFAULT_PUBLIC_ORIGIN
  }
}

function originFromEnv(
  envValue: string | undefined,
  fallback: () => string,
): string {
  const raw = envValue?.trim()
  if (!raw) return fallback()
  try {
    const href = raw.includes('://') ? raw : `https://${raw}`
    return new URL(href).origin
  } catch {
    return fallback()
  }
}

/**
 * Origin for `/blogs/*` canonical, sitemap entries, and share URLs. Defaults to
 * `NEXT_PUBLIC_SITE_URL`. Override with `NEXT_PUBLIC_BLOG_CANONICAL_ORIGIN`.
 */
export function getBlogCanonicalOrigin(): string {
  return originFromEnv(
    process.env.NEXT_PUBLIC_CANONICAL_ORIGIN,
    getPublicSiteOrigin,
  )
}

/**
 * Origin for `/security-advisories/*` canonical, sitemap entries, and share URLs. Defaults to
 * `NEXT_PUBLIC_SITE_URL`. Override with `NEXT_PUBLIC_ADVISORY_CANONICAL_ORIGIN`.
 */
export function getAdvisoryCanonicalOrigin(): string {
  return originFromEnv(
    process.env.NEXT_PUBLIC_CANONICAL_ORIGIN,
    getPublicSiteOrigin,
  )
}

/**
 * Canonical origin for ThreatLabz-hosted routes (`/cloud-insights/*`, `/malware-trends-tracker`, etc.).
 * Defaults to `NEXT_PUBLIC_SITE_URL`. Override with `NEXT_PUBLIC_THREATLABZ_CANONICAL_ORIGIN`.
 */
export function getThreatlabzCanonicalOrigin(): string {
  return originFromEnv(
    process.env.NEXT_PUBLIC_THREATLABZ_CANONICAL_ORIGIN,
    getPublicSiteOrigin,
  )
}
